var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  BASE_RECIPIENT: () => BASE_RECIPIENT,
  EMAIL_PERSONALIZATION_DEFAULTS: () => EMAIL_PERSONALIZATION_DEFAULTS,
  INFINITE_LIMIT_EXPR: () => INFINITE_LIMIT_EXPR,
  LOCAL_SIGNER_DEFAULT_PORT: () => LOCAL_SIGNER_DEFAULT_PORT,
  MAX_FILE_SIZE_BYTES: () => MAX_FILE_SIZE_BYTES,
  PLAN_FREE_NAME: () => PLAN_FREE_NAME,
  PLAN_STARTUPS_BASIC_NAME: () => PLAN_STARTUPS_BASIC_NAME,
  VALIDATE_DOCUMENT_MAX_FILE_SIZE: () => VALIDATE_DOCUMENT_MAX_FILE_SIZE,
  allowedFontFamilies: () => allowedFontFamilies,
  bindingFields: () => bindingFields,
  fontSizeOpts: () => fontSizeOpts,
  notificationEventsSupported: () => notificationEventsSupported,
  oauthScopes: () => oauthScopes,
  planPermissions: () => planPermissions,
  templatesDataTableColumns: () => templatesDataTableColumns,
  transactionReportColumns: () => transactionReportColumns
});
module.exports = __toCommonJS(index_exports);
var MAX_FILE_SIZE_BYTES = 2e7;
var fontSizeOpts = [
  7,
  8,
  9,
  10,
  11,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  36,
  48,
  72
];
var transactionReportColumns = [
  "id",
  "name",
  "status",
  "created_by",
  "created_at",
  "recipients",
  "sent_at",
  "completed_at",
  "team"
];
var templatesDataTableColumns = [
  "name",
  "created_by",
  "created_at",
  "updated_at",
  "_count"
];
var notificationEventsSupported = [
  "document_signed",
  "document_viewed",
  "email_viewed",
  "recipient_submitted",
  "transaction_completed",
  "transaction_forwarded",
  "transaction_rejected",
  "transaction_created",
  "transaction_expired",
  "transaction_started",
  "transaction_cancelled",
  "email_bounced",
  "email_delivered"
];
var BASE_RECIPIENT = {
  role: "sender",
  index: 0
};
var oauthScopes = [
  "transaction:read",
  "transaction:create",
  "transaction:update",
  "webhook:read",
  "webhook:create",
  "webhook:remove",
  "file:create",
  "template:read",
  "profile:read"
];
var bindingFields = [
  "signature_date",
  "person_name",
  "email"
];
var VALIDATE_DOCUMENT_MAX_FILE_SIZE = 2e6;
var planPermissions = [
  "can_create_template",
  "can_create_team",
  "can_invite_user",
  "can_create_folder",
  "can_customize_communication"
];
var PLAN_FREE_NAME = "Free";
var PLAN_STARTUPS_BASIC_NAME = "Startups basic";
var INFINITE_LIMIT_EXPR = -1;
var allowedFontFamilies = [
  "roboto",
  "space_grotesk",
  "barlow_condensed",
  "ibm_plex_sans_condensed",
  "playfair_display",
  "roboto_condensed",
  "roboto_mono",
  "space_mono",
  "helvetica"
];
var EMAIL_PERSONALIZATION_DEFAULTS = {
  banner_color: "#b269fb",
  banner_text_color: "#ffffff",
  footer_color: "#DDD",
  footer_text_color: "#0F1119",
  primary_color: "#DCF764",
  secondary_color: "#0F1119"
};
var LOCAL_SIGNER_DEFAULT_PORT = 50765;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BASE_RECIPIENT,
  EMAIL_PERSONALIZATION_DEFAULTS,
  INFINITE_LIMIT_EXPR,
  LOCAL_SIGNER_DEFAULT_PORT,
  MAX_FILE_SIZE_BYTES,
  PLAN_FREE_NAME,
  PLAN_STARTUPS_BASIC_NAME,
  VALIDATE_DOCUMENT_MAX_FILE_SIZE,
  allowedFontFamilies,
  bindingFields,
  fontSizeOpts,
  notificationEventsSupported,
  oauthScopes,
  planPermissions,
  templatesDataTableColumns,
  transactionReportColumns
});
